/**
 * 内容专题详情顶级组件
 * @author chenqunfeng
 * @since 17/11/06
 */

import './modal.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PreviewDialog from 'containers/preview-dialog';

const modalComponents = {
  PREVIEW_MODAL: PreviewDialog,
  PREVIEW_VIDEO_MODAL: PreviewDialog,
  PREVIEW_GAME_MODAL: PreviewDialog,
};

class Modal extends Component {
  static propTypes = {
    modal: PropTypes.object,
    userInfo: PropTypes.object,
    hideModal: PropTypes.func,
  };

  render() {
    const { modalType, modalProps } = this.props.modal;
    const SpecificModal = modalComponents[modalType];

    if (!SpecificModal) {
      return null;
    }

    return (
      <SpecificModal
        modalType={modalType}
        data={modalProps}
        userInfo={this.props.userInfo}
        hideModal={this.props.hideModal}
      />
    );
  }
}

export default Modal;
